const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M25.9405%2016.7177L16.294%206L13.0703%208.90589L23.0237%2019.9531L25.9405%2016.7177Z'%20fill='%2330A6E0'/%3e%3cpath%20d='M13%2031.0939L16.2114%2033.9998L28.859%2019.9527L25.9407%2016.7173L13%2031.0939Z'%20fill='%23F65E64'/%3e%3c/svg%3e";
export {
  e as default
};
